import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dashboard-header" }
const _hoisted_2 = { class: "dashboard-left" }
const _hoisted_3 = { class: "dashboard-title" }
const _hoisted_4 = {
  key: 0,
  class: "dashboard-subtitle"
}
const _hoisted_5 = {
  key: 0,
  class: "mdi has-text-success is-size-5 mdi-crosshairs-gps mr-1"
}
const _hoisted_6 = {
  key: 1,
  class: "has-first-letter-uppercase"
}
const _hoisted_7 = {
  key: 0,
  class: "is-hidden-desktop-only ml-1"
}
const _hoisted_8 = {
  key: 1,
  class: "has-first-letter-uppercase ml-1"
}
const _hoisted_9 = {
  key: 2,
  class: "mdi mdi-help-circle ml-1"
}
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "is-flex is-justify-content-start is-align-items-center" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "is-size-5 mdi mdi-crosshairs-question" }, null, -1 /* HOISTED */)
const _hoisted_14 = { class: "ml-1" }
const _hoisted_15 = { class: "dashboard-actions" }
const _hoisted_16 = { class: "has-first-letter-uppercase mr-1" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "mdi mdi-chart-bar" }, null, -1 /* HOISTED */)
const _hoisted_18 = { class: "has-first-letter-uppercase mr-1" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "mdi mdi-pencil" }, null, -1 /* HOISTED */)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "mdi mdi-television" }, null, -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_tooltip = _resolveComponent("n-tooltip")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_button_group = _resolveComponent("n-button-group")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_station_edition_modal = _resolveComponent("station-edition-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.currentStationName), 1 /* TEXT */),
      (_ctx.location)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_ctx.temperatureExt && _ctx.city)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5))
              : _createCommentVNode("v-if", true),
            (_ctx.temperatureExt && _ctx.city)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$t('dashboard.header.meteo', { temperature: _ctx.temperatureExt, city: _ctx.city})), 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            _createVNode(_component_n_tooltip, { style: { maxWidth: '400px' } }, {
              trigger: _withCtx(() => [
                _createElementVNode("div", null, [
                  (_ctx.aqiSentenceShort)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.aqiSentenceShort), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                  (_ctx.aqiExt)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, "AQI " + _toDisplayString(_ctx.aqiExt) + " / 100", 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                  (_ctx.aqiSentenceShort || _ctx.aqiExt)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9))
                    : _createCommentVNode("v-if", true)
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("span", { innerHTML: _ctx.aqiSentence }, null, 8 /* PROPS */, _hoisted_10)
              ]),
              _: 1 /* STABLE */
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_n_button, {
                type: "warning",
                ghost: "",
                round: "",
                onClick: _ctx.localizeStation
              }, {
                default: _withCtx(() => [
                  _hoisted_13,
                  _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('dashboard.header.missing_location')), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["onClick"])
            ])
          ]))
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createVNode(_component_n_button_group, {
        class: "mr-1",
        size: "large"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_n_button, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setMode('hour'))),
            round: "",
            type: _ctx.mode === 'hour' ? 'primary' : 'default'
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('time.n-hour', 6)), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["type"]),
          _createVNode(_component_n_button, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setMode('day'))),
            round: "",
            type: _ctx.mode === 'day' ? 'primary' : 'default'
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('time.n-hour', 24)), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["type"]),
          _createVNode(_component_n_button, {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setMode('week'))),
            round: "",
            type: _ctx.mode === 'week' ? 'primary' : 'default'
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('time.n-week', 1)), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["type"]),
          _createVNode(_component_n_button, {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setMode('month'))),
            round: "",
            type: _ctx.mode === 'month' ? 'primary' : 'default'
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('time.n-month', 1)), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["type"])
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_router_link, {
        to: {name: 'advanced-view', params: { station: _ctx.currentStation?.id}}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_n_button, {
            class: "mr-1",
            round: "",
            size: "large"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('dashboard.header.advanced_view')), 1 /* TEXT */),
              _hoisted_17
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["to"]),
      _createVNode(_component_router_link, { to: {name: 'dashboard-edit'} }, {
        default: _withCtx(() => [
          _createVNode(_component_n_button, {
            class: "mr-1",
            round: "",
            size: "large"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t('dashboard.header.edit')), 1 /* TEXT */),
              _hoisted_19
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_n_button, {
        class: "mr-1",
        round: "",
        size: "large",
        onClick: _ctx.refresh
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", {
            class: _normalizeClass([{spin: _ctx.isLoading}, "mdi mdi-refresh"])
          }, null, 2 /* CLASS */)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["onClick"]),
      (this.currentStation?.pairing_token)
        ? (_openBlock(), _createBlock(_component_n_button, {
            key: 0,
            class: "mr-1",
            round: "",
            size: "large",
            href: _ctx.tvLink,
            tag: "a",
            target: "_blank"
          }, {
            default: _withCtx(() => [
              _hoisted_20
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["href"]))
        : _createCommentVNode("v-if", true)
    ]),
    _createVNode(_component_station_edition_modal, { ref: "stationEditionModal" }, null, 512 /* NEED_PATCH */)
  ]))
}